import React from "react";
import { Link } from "react-router-dom";
import {
  FaPaperPlane,
  FaEllipsisH,
  FaComments,
  FaCamera,
  FaShareAlt,
  FaRegThumbsUp,
  FaRegThumbsDown,
  FaThumbsDown,
  FaThumbsUp,
  FaTimes,
  FaUser,
} from "react-icons/fa";
import "./styles/WallFeed.css";
import { connect } from "react-redux";
import * as actions from "../redux/actions/wallActions";
import * as actions_comment from "../redux/actions/adCommentActions";
import { Translate, I18n } from "react-redux-i18n";
import ModalGalery from "../components/ModalGalery";
import ModalReportComment from "./ModalReportComment";
import MiniLoader from "./MiniLoader";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import YoutubeEmbed from "./YoutubeEmbed";
import { convertToWebp } from "../utils/imageUtils";

function getEmbedId(url) {
  if (!url) return false;
  const array = url.split(" ");
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    if (element.indexOf("https://") >= 0) {
      const match = element.match(regExp);
      if (match && match[7].length === 11) {
        return match[7];
      }
    }
  }
  return false;
}

function getLocationLabel(ad) {
  if (!ad || !ad.State) return "";
  return [ad.State, ad.City].filter(Boolean).join(", ");
}

class WallItem extends React.Component {
  state = { menuOpen: false };

  toggleMenu = () => {
    this.setState((state) => ({ menuOpen: !state.menuOpen }));
  };

  closeMenu = () => {
    this.setState({ menuOpen: false });
  };

  handleMenuAction = (action) => {
    this.closeMenu();
    action();
  };

  render() {
    const { comment, user_id } = this.props;
    const isUp = comment.Like === 1;
    const isDown = comment.Like === 0;
    const embedId = getEmbedId(comment.Text);
    const location = getLocationLabel(comment.Ad);
    const subComments =
      comment.CountSubComment ?? comment.Count_subcomment ?? 0;
    const isOwner = comment.UserId?.toString() === user_id;

    return (
      <article className="wall-post-card">
        <header className="wall-post-header">
          <img
            className="wall-post-avatar"
            src={comment.Avatar}
            alt={comment.Name}
          />
          <div className="wall-post-meta">
            <p className="wall-post-name">
              {comment.HasStore && comment.Store?.Id ? (
                <Link to={`/marketstore/show/${comment.Store.Id}`}>
                  {comment.Name}
                </Link>
              ) : (
                <span>{comment.Name}</span>
              )}
            </p>
            <div className="wall-post-submeta">
              {location && <span>{location}</span>}
              {comment.CreatedAt && <span>{comment.CreatedAt}</span>}
            </div>
          </div>
          <div className="wall-post-menu">
            <button
              type="button"
              className="wall-post-menu-btn"
              aria-label="Options"
              onClick={this.toggleMenu}
              onBlur={() => setTimeout(this.closeMenu, 150)}
            >
              <FaEllipsisH />
            </button>
            {this.state.menuOpen && (
              <ul className="wall-post-menu-dropdown">
                <li>
                  <button
                    type="button"
                    onMouseDown={() =>
                      this.handleMenuAction(
                        isOwner
                          ? this.props.onClickRemove
                          : this.props.onClickReport
                      )
                    }
                  >
                    <Translate
                      value={isOwner ? "comment_remove" : "comment_report"}
                    />
                  </button>
                </li>
              </ul>
            )}
          </div>
        </header>

        <div className="wall-post-body">
          {embedId && <YoutubeEmbed embedId={embedId} />}
          {comment.Text && (
            <p className="wall-post-text">{comment.Text}</p>
          )}
          {comment.Ad?.Name && (
            <span className="wall-post-ad-name">{comment.Ad.Name}</span>
          )}
          {comment.HasMedia && (
            <div className="wall-post-media">
              <Link to="/galery">
                <img src={comment.Media} alt="" />
              </Link>
            </div>
          )}
          {comment.Ad?.Id && comment.Ad?.Photo && (
            <Link
              to={`/goder/show/${comment.Ad.Id}`}
              className="wall-post-ad-link"
            >
              <img src={comment.Ad.Photo} alt={comment.Ad.Name || ""} />
            </Link>
          )}
        </div>

        <footer className="wall-post-footer">
          <div className="wall-post-actions">
            <Link
              to={`/comment/${comment.Id}`}
              className="wall-post-action-btn"
              onClick={this.props.onClickSetItemComment}
            >
              <FaComments />
              <span>{subComments}</span>
            </Link>
            <button type="button" className="wall-post-action-btn">
              <FaShareAlt />
              <span>{comment.CountShare ?? 0}</span>
            </button>
          </div>

          <div className="wall-post-like-bar">
            <button
              type="button"
              className={`wall-post-like-btn${isUp ? " is-active-up" : ""}`}
              onClick={this.props.onClickUp}
            >
              {isUp ? <FaThumbsUp /> : <FaRegThumbsUp />}
              <span>{comment.CountLike}</span>
            </button>
            <span className="wall-post-like-divider" />
            <button
              type="button"
              className={`wall-post-like-btn${isDown ? " is-active-down" : ""}`}
              onClick={this.props.onClickDown}
            >
              {isDown ? <FaThumbsDown /> : <FaRegThumbsDown />}
              <span>{comment.CountUnlike}</span>
            </button>
          </div>
        </footer>
      </article>
    );
  }
}

class WallComments extends React.Component {
  state = {
    comment_text: "",
    disabled: true,
    image: "",
    file: "",
    hasFile: false,
    loading: false,
    reportModalOpen: false,
    reportCommentItem: null,
  };

  onClickSendComment = async () => {
    if (!this.state.hasFile && this.state.comment_text === "") return;

    this.setState({ loading: true });
    const params = new FormData();
    if (this.state.hasFile) {
      const webpFile = await convertToWebp(this.state.file);
      params.append("image", webpFile);
    }
    if (this.state.comment_text !== "") {
      params.append("comment", this.state.comment_text);
    }
    params.append("id", this.props.user_id);

    await this.props.AddComment(this.props.token, params).then(() => {
      if (this.props.error) {
        alertify.warning(I18n.t(this.props.error));
        this.setState({ loading: false });
      } else {
        this.setState({
          comment_text: "",
          image: "",
          file: "",
          hasFile: false,
          disabled: true,
          loading: false,
        });
      }
    });
  };

  onChangeImage = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState({
        file,
        image: reader.result,
        hasFile: true,
        disabled: false,
      });
    };
    reader.readAsDataURL(file);
  };

  removeImage = () => {
    this.setState({
      file: "",
      image: "",
      hasFile: false,
      disabled: this.state.comment_text.length === 0,
    });
  };

  onChangeComment = (event) => {
    const comment = event.target.value;
    this.setState({
      comment_text: comment,
      disabled: comment.length === 0 && !this.state.hasFile,
    });
  };

  onClickUp = async (item) => {
    if (item.Like === 1) {
      await this.props.RemoveLike(this.props.token, {
        comment_id: item.Id,
        id: this.props.user_id,
        lang: I18n.t("locale"),
      });
    } else {
      await this.props.UpdateLike(this.props.token, {
        comment_id: item.Id,
        status: "1",
        id: this.props.user_id,
        lang: I18n.t("locale"),
      });
    }
  };

  onClickDown = async (item) => {
    if (item.Like === 0) {
      await this.props.RemoveLike(this.props.token, {
        comment_id: item.Id,
        id: this.props.user_id,
        lang: I18n.t("locale"),
      });
    } else {
      await this.props.UpdateLike(this.props.token, {
        comment_id: item.Id,
        status: "'0'",
        id: this.props.user_id,
      });
    }
  };

  onClickSetItemComment = (item) => {
    this.props.SetCommentItem(item);
  };

  onClickReportComment = (item) => {
    this.setState({
      reportModalOpen: true,
      reportCommentItem: item,
    });
  };

  onCloseReportModal = () => {
    this.setState({
      reportModalOpen: false,
      reportCommentItem: null,
    });
  };

  onClickRemoveComment = async (item) => {
    await this.props.RemoveComment(this.props.token, {
      comment_id: item.Id,
      id: this.props.user_id,
      lang: I18n.t("locale"),
    });
  };

  onClickLoadMore = async () => {
    try {
      await this.props
        .LoadWallMore(this.props.token, {
          index: this.props.pageCount,
          id: this.props.user_id,
          lang: I18n.t("locale"),
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const userAvatar = this.props.user?.avatar;

    return (
      <section className="wall-feed">
        <div className="wall-feed-composer">
          <div className="wall-feed-composer-inner">
            {userAvatar ? (
              <img
                className="wall-feed-composer-avatar"
                src={userAvatar}
                alt=""
              />
            ) : (
              <div className="wall-feed-composer-avatar">
                <FaUser />
              </div>
            )}
            <div className="wall-feed-composer-field">
              <textarea
                name="comment_msg"
                className="wall-feed-composer-textarea"
                placeholder={I18n.t("comment_placeholder")}
                value={this.state.comment_text}
                onChange={this.onChangeComment}
                disabled={this.state.loading}
              />
              {this.state.hasFile && (
                <div className="wall-feed-composer-preview">
                  <img src={this.state.image} alt="" />
                  <button
                    type="button"
                    className="wall-feed-composer-preview-remove"
                    onClick={this.removeImage}
                    aria-label="Remove image"
                  >
                    <FaTimes />
                  </button>
                </div>
              )}
              <div className="wall-feed-composer-actions">
                <div>
                  <input
                    accept="image/*"
                    id="wall_open_input_img"
                    type="file"
                    className="wall-feed-attach-input"
                    onChange={this.onChangeImage}
                  />
                  <label htmlFor="wall_open_input_img" className="wall-feed-tool-btn">
                    <FaCamera />
                  </label>
                </div>
                <button
                  type="button"
                  className="wall-feed-send-btn"
                  disabled={this.state.disabled || this.state.loading}
                  onClick={this.onClickSendComment}
                >
                  <FaPaperPlane />
                  <Translate value="store_reviews_send" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {this.state.loading && (
          <div className="wall-page-loading">
            <MiniLoader />
          </div>
        )}

        {this.props.wallList.length === 0 ? (
          <div className="wall-feed-empty">
            <Translate value="wall_feed_empty" />
          </div>
        ) : (
          <div className="wall-feed-list">
            {this.props.wallList.map((item) => (
              <WallItem
                comment={item}
                key={item.Id}
                user_id={this.props.user_id}
                onClickUp={() => this.onClickUp(item)}
                onClickDown={() => this.onClickDown(item)}
                onClickSetItemComment={() => this.onClickSetItemComment(item)}
                onClickRemove={() => this.onClickRemoveComment(item)}
                onClickReport={() => this.onClickReportComment(item)}
              />
            ))}
          </div>
        )}

        {this.props.pageSize > 6 &&
          (this.props.loadingMore ? (
            <div className="wall-page-loading">
              <MiniLoader />
            </div>
          ) : (
            <div className="wall-feed-load-more">
              <button
                type="button"
                className="wall-feed-load-more-btn"
                onClick={this.onClickLoadMore}
              >
                <Translate value="load_more" />
              </button>
            </div>
          ))}

        <ModalGalery />
        <ModalReportComment
          isOpen={this.state.reportModalOpen}
          onClose={this.onCloseReportModal}
          comment={this.state.reportCommentItem}
        />
      </section>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    user: reducer.session.auth,
    error: reducer.wall.error,
    wallList: reducer.wall.list,
    loading: reducer.wall.loading,
    loadingMore: reducer.wall.loadingMore,
    pageSize: reducer.wall.page_size,
    pageCount: reducer.wall.page_count,
  };
}

const mapDispatchToProps = (dispatch) => ({
  AddComment: (token, params) => dispatch(actions.addComment({ token, params })),
  RemoveLike: (token, params) =>
    dispatch(actions.removeLike({ token, params })),
  UpdateLike: (token, params) =>
    dispatch(actions.updateLike({ token, params })),
  RemoveComment: (token, params) =>
    dispatch(actions.removeComment({ token, params })),
  LoadWallMore: (token, params) =>
    dispatch(actions.loadListScroll({ token, params })),
  SetCommentItem: (item) => dispatch(actions_comment.setCommentItem({ item })),
});

export default connect(mapStateToProps, mapDispatchToProps)(WallComments);
